import { BASE_HOST_URL } from '@/helpers/host-helper'

export class KeycloakConfig {
  /**
   * Creates a Keycloak Configuration
   * @param idp identity provider
   * @param onAuth post authentication callback function
   */
  constructor(idp, onAuth) {
    this.config = {
      authRealm: window.$appConfig.VUE_APP_KEYCLOAK_REALM,
      authUrl: window.$appConfig.VUE_APP_KEYCLOAK_AUTH_URL,
      authClientId: window.$appConfig.VUE_APP_KEYCLOAK_CLIENT_ID,
      logoutRedirectUri:
        BASE_HOST_URL +
        window.$appConfig.VUE_APP_KEYCLOAK_LOGOUT_REDIRECT +
        (idp !== undefined ? '?dl_idp_hint=' + idp : '')
    }

    this.init = {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    }

    this.onReady = async kc => {
      if (!kc.authenticated) {
        await kc.login({ idpHint: idp })
      }
      onAuth()
    }
  }
}
